import script from "./StaffDashboardView.vue?vue&type=script&setup=true&lang=js"
export * from "./StaffDashboardView.vue?vue&type=script&setup=true&lang=js"

import "./StaffDashboardView.vue?vue&type=style&index=0&id=83e5d8ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-83e5d8ce"]])

export default __exports__